import { FormFieldTypes } from "../../../../data/formFieldType";

export const AccountInformationData = {
  name: "AdditionalInfo",
  initialState: {
    membershipTypeId: null,
    joinedDate: null,
    membershipStatusId: null,
  },
  formFields: [
    {
      id: "membershipTypeId",
      lable: "Membership  Type  ",
      Field_Name: "Membership Type",
      fieldType: FormFieldTypes.SELECT,
      dataField: "membershipTypeId",
      fieldSetting: {
        placeholder: "",
        options: [],
        isDisable: true,
      },
      style: {
        containerCss: "col-lg-5 col-xl-5 col-md-5 col-sm-12 col-12 mb-2 mb-3",
      },
    },
    {
      id: "joinedDate",
      lable: "Joined Date",
      Field_Name: "Joined Date",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "joinedDate",
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
        isDisable: true,
      },
      style: {
        containerCss: "col-lg-5 col-xl-5 col-md-5 col-sm-12 col-12 mb-2",
      },
    },
    {
      id: "membershipStatusId",
      lable: "Membership Status  ",
      Field_Name: "MembershipStatus",
      fieldType: FormFieldTypes.SELECT,
      dataField: "membershipStatusId",
      fieldSetting: {
        placeholder: "",
        options: [],
        isDisable: true,
      },
      style: {
        containerCss: "col-lg-5 col-xl-5 col-md-5 col-sm-12 col-12 mb-2 mb-3",
      },
    },
  ],
  formSetting: {
    isViewOnly: true,
  },
};